import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import GalleryComponent1 from '../../galleryComponents/galleryComponent1/GalleryComponent1';
import './css/ArticleComponent1.css';
import GameWidget1 from '../../gamesWidgets/gameWidget1/GameWidget1';
import { getWebsiteImage } from '../../../../catalog/Website';
import { ARTICLE_DELETED, ARTICLE_NOT_PUBLISHED } from '../../../../catalog/Comments';
import PlaceholderComponent1 from '../../placeholderComponents/placeholderComponent1/PlaceholderComponent1';
import ImageWithTitleComponent1 from '../../imageWithTitleComponents/imageWithTitleComponent1/ImageWithTitleComponent1';
import { getFullDateStringFromDate, getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import { opponentGoalsDescription as opponentIceHockeyGoalsDescription, ourGoalsDescription as ourIceHockeyGoalsDescription } from '../../../../catalog/stats/iceHockey/IceHockeyStatsDescription';
import { opponentGoalsDescription as opponentLacrosseGoalsDescription, ourGoalsDescription as ourLacrosseGoalsDescription } from '../../../../catalog/stats/lacrosse/LacrosseStatsDescription';
import { SportsType } from '../../../../catalog/enums/SportsType';
import { opponentPointsDescriptionFromGame, ourPointsDescriptionFromGame } from '../../../../catalog/stats/rugby/RugbyStatsDescription';
import ShareComponent1 from '../../shareComponents/shareComponent1/ShareComponent1';
import { getArticleShareTitle, getArticleURL } from '../../../../catalog/Social';

const ArticleComponent1 = (props) => {
    const { id, title, author, featureImage, content, mobileContent, timeOfArticle, galleryId, photos, galleryPublished, game, gameId, opponentName, opponentLogo, gameStatus, homeGame, timeOfGame, deleted, published, loadingSpinner, galleryLoadingSpinner, gameLoadingSpinner } = props;
    const { globalState } = useContext(context);

    const getImage = () => {
        if (isValidString(featureImage)) {
            return featureImage;
        } if (isValidObject(getWebsiteImage(globalState, 'articleFeatureImage'))) {
            return getWebsiteImage(globalState, 'articleFeatureImage');
        }
        return '';
    };

    const placeholderArticleContent = () => {
        if (deleted) {
            return (<PlaceholderComponent1 text={ARTICLE_DELETED} />);
        } if (!published) {
            return (<PlaceholderComponent1 text={ARTICLE_NOT_PUBLISHED} />);
        }
        return null;
    };

    const showArticle = () => {
        if (deleted) {
            return false;
        } if (!published) {
            return false;
        }
        return true;
    };

    // eslint-disable-next-line no-unused-vars
    const isUpcomingGame = () => {
        if (isValidObject(timeOfGame) && isValidObject(timeOfGame.seconds)) {
            return getLocalTimeFromDatabaseTime(timeOfGame) > new Date();
        }
        return true;
    };

    const getAuthorAndDate = () => {
        if (isValidString(author)) {
            return (
                <div className="article-component1-author-container">
                    <h2 className="article-component1-author font-size-xl alegreya-font-family font-weight-400 text-left-align font-spacing-normal text-gray m-t-0 m-b-30px m-l-50px m-r-20px">{`By: ${author}`}</h2>
                    <h2 className="article-component1-dot font-size-xl alegreya-font-family font-weight-400 text-left-align font-spacing-normal text-gray m-t-0 m-b-30px m-l-5px m-r-5px">●</h2>
                    <h2 className="article-component1-time font-size-xl alegreya-font-family font-weight-400 text-left-align font-spacing-normal text-gray m-t-0 m-b-30px m-l-20px m-r-20px">{getFullDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfArticle))}</h2>
                </div>
            );
        }
        return (
            <div>
                <h2 className="article-component1-time font-size-xl alegreya-font-family font-weight-400 text-left-align font-spacing-normal text-gray m-t-0 m-b-30px m-l-50px m-r-50px">{getFullDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfArticle))}</h2>
            </div>
        );
    };

    // eslint-disable-next-line no-unused-vars
    const getScoreDescription = (our) => {
        if (our) {
            if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
                return ourIceHockeyGoalsDescription(game.goals);
            }
            if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
                return ourPointsDescriptionFromGame(game);
            }
            if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
                return ourLacrosseGoalsDescription(game.goals);
            }
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return opponentIceHockeyGoalsDescription(game.goals);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return opponentPointsDescriptionFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return opponentLacrosseGoalsDescription(game.goals);
        }
        return [];
    };

    const isValidContent = (localContent) => {
        if (!isValidString(localContent)) {
            return false;
        }
        if (localContent === '<p></p>') {
            return false;
        }
        return true;
    };

    return (
        <div className="article-component1-container-container x-center m-b-50px">
            <div className="article-component1-container box-shadow-black bg-white curve-border-40px x-center p-t-100px p-b-100px p-l-100px p-r-100px m-t-50px">
                <h1 className="article-component1-title font-size-4xl alegreya-font-family font-weight-800 text-left-align font-spacing-wider text-uppercase m-t-0 m-b-30px m-l-50px m-r-50px">{title}</h1>
                {loadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} /> : (
                    <>
                        {showArticle() ? (
                            <>
                                <ShareComponent1
                                    title="Article"
                                    image={getImage()}
                                    url={getArticleURL(globalState, id)}
                                    shareTitle={getArticleShareTitle(title, globalState.teamAlias, author)}
                                    marginTop={0}
                                    marginBottom={20}
                                    mobileMarginBottom={20}
                                />
                                {getAuthorAndDate()}
                                <ImageWithTitleComponent1 title={title} image={getImage()} alt="Article Feature Image" />
                                <div className="m-t-50px"></div>
                                {isValidString(gameId) ? (
                                    <>
                                        {gameLoadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} size={50} marginTop={100} /> : (
                                            <>
                                                <GameWidget1 id={gameId} game={game} opponentName={opponentName} opponentLogo={opponentLogo} status={gameStatus} homeGame={homeGame} timeOfGame={timeOfGame} />
                                                {/* {!homeGame ? (
                                                    <div className="article-component1-scorer-container x-center">
                                                        <div className="article-component1-scorer-left">
                                                            {isUpcomingGame() ? null : (
                                                                <>
                                                                    {getScoreDescription(true).map((score) => {
                                                                        return (
                                                                            score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-left-align font-size-xs full-width m-t-3px m-b-3px">{score}</div> : null
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="article-component1-scorer-right">
                                                            {isUpcomingGame() ? null : (
                                                                <>
                                                                    {getScoreDescription(false).map((score) => {
                                                                        return (
                                                                            score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-right-align font-size-xs full-width m-t-3px m-b-3px">{score}</div> : null
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="article-component1-scorer-container x-center">
                                                        <div className="article-component1-scorer-left">
                                                            {isUpcomingGame() ? null : (
                                                                <>
                                                                    {getScoreDescription(false).map((score) => {
                                                                        return (
                                                                            score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-right-align font-size-xs full-width m-t-3px m-b-3px">{score}</div> : null
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="article-component1-scorer-right">
                                                            {isUpcomingGame() ? null : (
                                                                <>
                                                                    {getScoreDescription(true).map((score) => {
                                                                        return (
                                                                            score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-left-align font-size-xs full-width m-t-3px m-b-3px">{score}</div> : null
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </>
                                        )}
                                    </>
                                ) : null}
                                <div className="article-component1-text alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-50px m-l-50px m-r-50px">
                                    {parse(content)}
                                </div>
                                <div className="article-component1-text-mobile alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-50px m-l-50px m-r-50px">
                                    {isValidContent(mobileContent) ? parse(mobileContent) : parse(content)}
                                </div>
                                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                    <img src={globalState.logo.logo2} className="article-component1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                                ) : null}
                            </>
                        ) : placeholderArticleContent()}
                    </>
                )}
            </div>
            {isValidString(galleryId) && isValidObject(photos) && photos.length > 0 && galleryPublished ? (
                <GalleryComponent1 id={galleryId} photos={photos} deleted={false} published={galleryPublished} loadingSpinner={galleryLoadingSpinner} />
            ) : null}
        </div>
    );
};

ArticleComponent1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    featureImage: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    mobileContent: PropTypes.string,
    timeOfArticle: PropTypes.object.isRequired,
    galleryId: PropTypes.string,
    photos: PropTypes.array,
    galleryPublished: PropTypes.bool,
    game: PropTypes.object,
    gameId: PropTypes.string,
    opponentName: PropTypes.string,
    opponentLogo: PropTypes.string,
    gameStatus: PropTypes.string,
    homeGame: PropTypes.bool,
    timeOfGame: PropTypes.object,
    deleted: PropTypes.bool.isRequired,
    published: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool,
    galleryLoadingSpinner: PropTypes.bool,
    gameLoadingSpinner: PropTypes.bool,
};

ArticleComponent1.defaultProps = {
    mobileContent: '',
    photos: [],
    galleryId: '',
    galleryPublished: false,
    game: {},
    gameId: '',
    opponentName: '',
    opponentLogo: '',
    gameStatus: 'tba',
    homeGame: false,
    timeOfGame: {},
    loadingSpinner: false,
    galleryLoadingSpinner: false,
    gameLoadingSpinner: false,
};

export default memo(ArticleComponent1);
